import React, {
  PropTypes,
} from 'react';

const SocialNetworkLink = ({ link = { platform: '', url: '', channelName: '' } }) => (
  <a href={link.url} target="_blank">
    <div className={`col-md-6 social-link ${link.platform}`}>
      { link.channelName }
    </div>
  </a>
);

SocialNetworkLink.propTypes = {
  link: PropTypes.object.isRequired,
};

export default SocialNetworkLink;



// WEBPACK FOOTER //
// ./src/components/social-network-link/index.js